import { createSelector } from 'reselect';
import StarTitle from '@atlassian/jira-common-directory-v2/src/components/star-title-cell/view.tsx';
import { COPY, DELETE, MOVE } from '@atlassian/jira-directory-base/src/model/operation-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { NAME } from '../model/sort-field.tsx';
import { getLoggedInUserAccountId } from '../state/selectors/app/index.tsx';
import TypeActions from './content/cells/actions/index.tsx';
import AdministratorsCell from './content/cells/administrators/index.tsx';
import FavoriteCell from './content/cells/favourite/index.tsx';
import LocationWithActionsCell from './content/cells/location-with-actions/index.tsx';
import LocationCell from './content/cells/location/index.tsx';
import TitleCell from './content/cells/title/index.tsx';
import CopyModal from './copy-modal/index.tsx';
import DeleteModal from './delete-modal/index.tsx';
import messages from './messages.tsx';
import MoveModal from './move-modal/index.tsx';

export const operationModals = {
	[DELETE]: DeleteModal,
	[COPY]: CopyModal,
	[MOVE]: MoveModal,
} as const;

export const emptyFilterResultConfiguration = {
	message: messages.emptyFilterResultMessage,
} as const;

export const getTableConfiguration = createSelector(
	getLoggedInUserAccountId,
	(loggedInUserAccountId) =>
		[
			loggedInUserAccountId !== null
				? {
						title: StarTitle,
						Cell: FavoriteCell,
						width: 3,
					}
				: undefined,
			{
				title: messages.name,
				Cell: TitleCell,
				sortField: NAME,
				width: loggedInUserAccountId ? 49 : 55,
			},
			{
				title: messages.administrators,
				Cell: AdministratorsCell,
				width: 20,
			},
			{
				title: messages.location,
				Cell:
					loggedInUserAccountId !== null && isVisualRefreshEnabled() && fg('visual-refresh_drop_4')
						? LocationWithActionsCell
						: LocationCell,
				width:
					loggedInUserAccountId !== null && isVisualRefreshEnabled() && fg('visual-refresh_drop_4')
						? 28
						: 25,
			},
			// delete this when cleaning up visual-refresh_drop_4 FG
			loggedInUserAccountId !== null && !(isVisualRefreshEnabled() && fg('visual-refresh_drop_4'))
				? {
						...(fg('jfp-a11y-team_boards_empty-heading') && { title: messages.actions }),
						Cell: TypeActions,
						width: 3,
						dataTestId: 'boards-main.content.headerCell.actions.container',
					}
				: undefined,
		].filter(Boolean),
);

export const getTableLabel = () => messages.tableAriaLabel;

export const getResultsAnnouncerMessage = () => messages.filterResultsAnnouncement;
